export default {
  slots: {
    overlay: 'fixed inset-0 backdrop-blur-sm',
    content:
      'fixed bg-(--ui-modal-background) divide-y divide-(--ui-border) flex flex-col focus:outline-none border-[10px] rounded-2xl shadow-none border-[#43464A]',
  },
  variants: {
    fullscreen: {
      false: {
        content:
          'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100vw-2rem)] max-w-lg max-h-[calc(100dvh-2rem)] rounded-2xl shadow-lg ring ring-(--ui-border)',
      },
      true: {
        overlay: 'bg-[#43464A]',
      },
    },
    overlay: {
      true: {
        overlay: 'bg-overlay-dark',
      },
    },
  },
};
